import {
  Button,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
  Tab,
  TabPanel,
  Tabs,
} from "../../../components";
import { tiposPessoaEnum } from "../constantes";
import { TabCliente, TabColaborador, TabEndereco, TabFornecedor, TabPrestadorServico, TabProfissional, TabTransportadora } from "../tabs";

export function InformacoesPessoasDialog({
  open,
  setOpen,
  dadosPessoa,
  linhaSelecionada,
  abaValue, 
  setAbaValue,
  estados,
  inputErros,
  setLoading,
  cacheDto,
  setCacheDto,
  enderecoService
}) {
  function onClose() {
    setOpen(false);
  }

  const tabProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  };

  return (
    <Dialog fullWidth maxWidth={"lg"} open={open} onClose={onClose}>
      <CardHeader title="Informações Adicionais" className="m-2" />
      <DialogContent>
        <Paper>
          <Tabs
            value={abaValue}
            onChange={(_, value) => setAbaValue(value)}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            scrollButtons="auto"
          >
            <Tab
              label="Endereço"
              disabled={dadosPessoa?.endereco ? false : true}
              {...tabProps(0)}
            />
            <Tab
              label="Cliente"
              disabled={dadosPessoa?.cliente ? false : true}
              {...tabProps(tiposPessoaEnum["CLIENTE"] + 1)}
            />
            <Tab
              label="Fornecedor"
              disabled={dadosPessoa?.fornecedor ? false : true}
              {...tabProps(tiposPessoaEnum["FORNECEDOR"] + 1)}
            />
            <Tab
              label="Transportadora"
              disabled={dadosPessoa?.transportadora ? false : true}
              {...tabProps(tiposPessoaEnum["TRANSPORTADORA"] + 1)}
            />
            <Tab
              label="Colaborador"
              disabled={dadosPessoa?.colaborador ? false : true}
              {...tabProps(tiposPessoaEnum["COLABORADOR"] + 1)}
            />
            <Tab
              label="Prest. Serviço"
              disabled={dadosPessoa?.prestadorServico ? false : true}
              {...tabProps(tiposPessoaEnum["PRESTADOR"] + 1)}
            />
            <Tab
              label="Profissional"
              disabled={dadosPessoa?.profissional ? false : true}
              {...tabProps(tiposPessoaEnum["PROFISSIONAL"] + 1)}
            />
          </Tabs>
        </Paper>
        <TabPanel value={abaValue} index={0}>
          <TabEndereco
            enderecoSelecionado={dadosPessoa?.endereco}
            linhaSelecionada={linhaSelecionada}
            estados={estados}
            cacheDto={cacheDto}
            setCacheDto={setCacheDto}
            inputErros={inputErros}
            setLoading={setLoading}
            enderecoService={enderecoService}
          />
        </TabPanel>
        <TabPanel value={abaValue} index={tiposPessoaEnum["CLIENTE"] + 1}>
          <TabCliente
            clienteSelecionado={dadosPessoa?.cliente}
            linhaSelecionada={linhaSelecionada}
            cacheDto={cacheDto}
            setCacheDto={setCacheDto}
            inputErros={inputErros}
          />
        </TabPanel>
        <TabPanel value={abaValue} index={tiposPessoaEnum["FORNECEDOR"] + 1}>
          <TabFornecedor
            fornecedorSelecionado={dadosPessoa?.fornecedor}
            linhaSelecionada={linhaSelecionada}
            cacheDto={cacheDto}
            setCacheDto={setCacheDto}
            inputErros={inputErros}
          />
        </TabPanel>
        <TabPanel value={abaValue} index={tiposPessoaEnum["TRANSPORTADORA"] + 1}>
          <TabTransportadora
            transportadoraSelecionada={dadosPessoa?.transportadora}
            linhaSelecionada={linhaSelecionada}
            cacheDto={cacheDto}
            setCacheDto={setCacheDto}
            inputErros={inputErros}
          />
        </TabPanel>
        <TabPanel value={abaValue} index={tiposPessoaEnum["COLABORADOR"] + 1}>
          <TabColaborador
            colaboradorSelecionado={dadosPessoa?.colaborador}
            linhaSelecionada={linhaSelecionada}
            cacheDto={cacheDto}
            setCacheDto={setCacheDto}
            inputErros={inputErros}
          />
        </TabPanel>
        <TabPanel value={abaValue} index={tiposPessoaEnum["PRESTADOR"] + 1}>
          <TabPrestadorServico
            prestadorSelecionado={dadosPessoa?.prestadorServico}
            linhaSelecionada={linhaSelecionada}
            cacheDto={cacheDto}
            setCacheDto={setCacheDto}
            inputErros={inputErros}
          />
        </TabPanel>
        <TabPanel value={abaValue} index={tiposPessoaEnum["PROFISSIONAL"] + 1}>
          <TabProfissional
            profissionalSelecionado={dadosPessoa?.profissional}
            linhaSelecionada={linhaSelecionada}
            cacheDto={cacheDto}
            setCacheDto={setCacheDto}
            inputErros={inputErros}
          />
        </TabPanel> 
      </DialogContent>
      <DialogActions className="m-3">
        <Button onClick={onClose} color="primary" variant="contained">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
